module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M50,24.38l-5.75-4.8a5.23,5.23,0,0,0-3.34-1.21H35.47v-.68a3.4,3.4,0,0,0-3.15-3.39v0h-21v0a3.4,3.4,0,0,0-3.2,3.39V38.21a3.42,3.42,0,0,0,3.42,3.41h2.23a5.46,5.46,0,0,0,10.58,0H37a5.46,5.46,0,0,0,10.57,0h.88a3.41,3.41,0,0,0,3.41-3.41V28.38A5.18,5.18,0,0,0,50,24.38ZM21.79,40.26a2.74,2.74,0,0,1-5.47,0v0s0,0,0,0a2.73,2.73,0,0,1,2.74-2.7h0a2.74,2.74,0,0,1,2.73,2.74Zm2.56-1.35a5.43,5.43,0,0,0-1.93-3,8.06,8.06,0,0,0,7.58-8h0a8,8,0,0,0-7.61-8,.59.59,0,0,0-.52.33.52.52,0,0,0,.11.59,5.1,5.1,0,1,1-7.19,7.21.55.55,0,0,0-.61-.11.51.51,0,0,0-.32.52,8.07,8.07,0,0,0,4.07,6.45,5.47,5.47,0,0,0-4.16,4H11.54a.68.68,0,0,1-.68-.68V17.69A.67.67,0,0,1,11.5,17H32.09a.67.67,0,0,1,.64.67v21.2h-8.2ZM42.3,43a2.73,2.73,0,0,1-2.73-2.72h0a2.73,2.73,0,0,1,2.73-2.72h0a2.74,2.74,0,1,1,0,5.47Zm6.84-4.77a.67.67,0,0,1-.67.67h-.88a5.46,5.46,0,0,0-10.57,0H35.47V21.1h5.45a2.5,2.5,0,0,1,1.58.58l5.75,4.8a2.44,2.44,0,0,1,.89,1.9Z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-894c01e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/OvernightIcon.vue
// module id = 749
// module chunks = 0